import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export var getUpdateCartFunction = function(updateFn, skipItemInventoryFetch) {
    return function(items, options) {
        return updateFn(items, _object_spread_props(_object_spread({}, options), {
            // When item-inventory API is called synchronously,
            // skipItemInventoryFetch should be set as well to
            // skip the fetch triggered by `CART_UPDATED_V2`
            // AppEvent in CartDataStoreV2.
            skipItemInventoryFetch: skipItemInventoryFetch
        }));
    };
};
